import { render, staticRenderFns } from "./MotorSettings.vue?vue&type=template&id=0d8d3b96&scoped=true"
import script from "./MotorSettings.vue?vue&type=script&lang=js"
export * from "./MotorSettings.vue?vue&type=script&lang=js"
import style0 from "./MotorSettings.vue?vue&type=style&index=0&id=0d8d3b96&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8d3b96",
  null
  
)

export default component.exports